
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
img,
picture{
  width:100%;
  height:100%;
  object-fit:cover;
}

.outline-hero--background > div{
    display:flex;
    flex-grow:1;
  }

div[slot='background']{
  flex-grow:1;
  display:flex;
}

div[slot='background'] > div{
    flex-grow:1;
  }

div[slot='background'] > outline-video-player{
    width:100%;
    height:100%;
    flex-grow:1;
  }
`;